export default (amount, fractionDigits = 2) => {
  let displayedAmount = !amount ? 0 : amount;
  return parseFloat(displayedAmount).toFixed(fractionDigits) + '%';
};
